import React from 'react';
import { Helmet } from "react-helmet";
// import _get from 'lodash/get';
import './style.css';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import Col from 'react-bootstrap/Col';
import Footer from 'components/Footer/Footer';
import Button from 'components/Button/Button';
// import CityImage from 'Assets/city-hero.png';
//import Tab from "react-bootstrap/Tab";
//import Tabs from 'react-bootstrap/Tabs';

import CityInfo from 'pages/City/CityInfo/CityInfo';
import ManageBanner from 'components/Banner/ManageBanner';
//import EventList from 'pages/EventList/EventList';
import EventList from 'components/EventListTable/EventList';
import Venues from './CityVenue';

//import CreateEvent from 'pages/CreateEvent/CreateEvent';
import { owner_perms, apiUrl, myHeaders_With_Cache_Control,user_entity_uuid, user_access_token,user_access_level,user_Status_Ver } from "Api/Api";
// ,myHeaders_Auth_With_Cache_Control
import axios from "axios";
// import { origin } from 'utils/Helper';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import presentation from 'Assets/presentation-deck.svg';
// import users from 'Assets/users.svg';
// import eye from 'Assets/eye.svg';
//import { Route, Switch, BrowserRouter as Router, withRouter,Link, NavLink } from "react-router-dom";
import { withRouter, NavLink } from "react-router-dom";
import { local_routes } from 'utils/Routes';
import home from 'Assets/home.svg';
import { Redirect } from 'react-router-dom';


//let locationUid;
let friendlyUrl = '';

class EditCity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location_data: {},
      pageLoader: true,
      allowed: true,
      currentTab: null,

      /*      
      key: 'home',
      pageStatus: 1,
      isLoader: false,
      friendly_url: '',
      recFriendlyUrl: '',
      friendlyUrlParams: null,
      pageLoader: true,
      city_name: '',
      editEventData: null,
      showSuccessData:null,
      successFriendlyUrl:null,
      successEntityName:null,
      allowed: true,
      currentTab:null,
      */
    };
    
    console.log("EditCity constructor",props);
    this.user_data = {};
        
    if (props.match.params.otherpage) {
      this.state.currentTab = props.match.params.otherpage;
    }
    
    /*
    if (props.match.params.otherpage) {
      if (props.match.params.otherpage === `main`) {
        this.state.currentTab = "main";
      } else if (props.match.params.otherpage === `events`) {
        this.state.currentTab = "events";
      } else if (props.match.params.otherpage === `venues`) {
        this.state.currentTab = "venues";
      } else {
        // bad tab!
      }
    }
    */
  }

  /*
  componentWillMount(){
    const { match } = this.props;
    friendlyUrl = _get(match, 'params.friendly_url', '');
  }
  */
  
  /*
  componentWillReceiveProps = async function() {
    console.log("EditCity componentWillReceiveProps",this.props.match.params);
    if (this.props.match.params.otherpage === `main`) {
      this.setState({currentTab:"main"})
    } else if( this.props.match.params.otherpage === `events`) {
      this.setState({currentTab:"events"})
    } else if(this.props.match.params.otherpage === `venues`) {
      this.setState({currentTab:"venues"})
    }
  }
  */
  
  componentDidUpdate (prevProps) {
      let { location: { pathname } } = this.props;

      if (prevProps.location.pathname === pathname) return;
      this.routeChanged();
  }

  routeChanged () {
    console.log("EditCity routeChanged");
    if (this.props.match.params.otherpage) {
      if (this.props.match.params.otherpage === `main`) {
        this.setState({currentTab:"main"})
      } else if( this.props.match.params.otherpage === `events`) {
        this.setState({currentTab:"events"})
      } else if(this.props.match.params.otherpage === `venues`) {
        this.setState({currentTab:"venues"})
      } else {
        // bad tab!
        this.setState({currentTab:null});
      }
    } else {
      // no tab!
      this.setState({currentTab:null});
    }
    
  }

  componentDidMount = async function () {
    console.log("EditCity componentDidMount");
    const { match: { params: { friendly_url } = {} } = {} } = this.props;
    /*
    if (this.props.match.params.otherpage === `main`) {
      this.setState({currentTab:"main"})
    } else if( this.props.match.params.otherpage === `events`) {
      this.setState({currentTab:"events"})
    } else if(this.props.match.params.otherpage === `venues`) {
      this.setState({currentTab:"venues"})
    }
    */
    window.scrollTo(0, 0);
    /*
    if(this.props && this.props.location && this.props.location.data === "eventTab")
    {
      this.setState({currentTab:"profile"})
    }
    */
    
    if (!user_access_token || user_Status_Ver !== "1") {
        this.setState({ allowed: false });
        return;
    }
    let allowed = false;
    if (user_access_level === "admin") {
        // allowed
        allowed = true;
    }
    if (owner_perms['locations'] && owner_perms['locations'][friendly_url] && owner_perms['locations'][friendly_url] === "admin") {
        // allowed
        allowed = true;
    }
    if (!allowed) {
        console.error("User not allowed to manage city");
        this.setState({ allowed: false });
        return;
    }


    try {
        let [location_data_response,user_data_response,user_location_data_response] = await Promise.all([
            axios.get(`${apiUrl}locations/${friendly_url}`, myHeaders_With_Cache_Control),
            axios.get(`${apiUrl}users/${user_entity_uuid}`, myHeaders_With_Cache_Control),
            //axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter[resident_integer][gte]=1`, myHeaders_With_Cache_Control),
            axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
        ]);
        this.user_data = user_data_response.data;
        this.user_data.locations = user_location_data_response.data;
        //org_data_response.data.channels = channels_data_response.data;
        
        location_data_response.data.city_image = "";
        if (location_data_response.data.city_skyline_wide_image_url) {
          location_data_response.data.city_image = location_data_response.data.city_skyline_wide_image_url;
        } else if (location_data_response.data.city_skyline_image_url) {
          location_data_response.data.city_image = location_data_response.data.city_skyline_image_url;
        }
        
        this.setState({ location_data:location_data_response.data, pageLoader: false});
    } catch (err) {
        this.setState({ pageLoader: false });
        return;
    }
    
    this.routeChanged();            
    
    
    
    /*
    //locationUid = this.props.match.params.friendly_url;
      if (!user_access_token || user_Status_Ver !== "1") {
        this.setState({ allowed: false });
        return;
      }
      if (user_access_level !== "admin") {
        try {
          let loc_users_response = await axios.get(`${apiUrl}locations/${friendlyUrl.toLowerCase()}/users`, myHeaders_Auth_With_Cache_Control);
          let owner_match = false;
          for (let pk_user of loc_users_response.data) {
            if (pk_user.entity_uuid === user_entity_uuid) {
              if (pk_user.xref_data && pk_user.xref_data.entity_owner_integer && pk_user.xref_data.entity_owner_integer >= 1) {
                owner_match = true;
                // this.setState({pageLoader:false})
                break;
              }
            }
          }
          if (!owner_match) {
            this.setState({ allowed: false,
              pageLoader:false 
            });
            return;
          }
        } catch (err) {
          this.setState({ allowed: false,pageLoader:false });
          return;
        }
      }    
    Promise.all([
      axios.get(`${apiUrl}locations/${friendlyUrl.toLowerCase()}`, myHeaders_With_Cache_Control)
    ])
      .then(([userDataRes]) => {
        if (userDataRes.data) {
          let recDataRes = userDataRes.data
          axios.get(`${apiUrl}locations/${recDataRes.entity_uuid}`, myHeaders_With_Cache_Control)
            .then((imageData) => {
              if (imageData.data) {
                this.setState({ city_name: imageData.data.entity_name })
              }
              const wideEventImg = _get(imageData, 'data.city_skyline_wide_image_url', '');
              const eventImg = _get(imageData, 'data.city_skyline_image_url', '');
              // set the all api data
              this.setState({
                isLoader: false,
                eventImg: wideEventImg || eventImg,
                pageLoader: false,
              });
            })
            .catch(() => this.setState({ isLoader: false, 
              pageLoader: false,
             }))
        }
      });
      */
  }

  // Navigation Links end
  // Banner section Start
  bannerApiImage = () => {
    //const { city_name, } = this.state;
    //const { match } = this.props;
    //const friendlyUrl = _get(match, 'params.friendly_url', '');
    
    //let url = this.state.eventImg;
    //let array = url.split("/");
    //let bannerImageUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1300x360/${array[5]}`;

    let bannerImageUrl = "";
    if (this.state.location_data.city_image) {
        let url = this.state.location_data.city_image;
        let array = url.split("/");
        bannerImageUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_900x360/${array[5]}`;
    }

    return (
      <div>
        <div className="eventImage city-chicago">
          { bannerImageUrl &&
              <img src={bannerImageUrl} className="city-img" alt="img" />
          }

          <div className="container contentPosition">
            <div className="city-name">
              <h1 className="cityName">{this.state.location_data.entity_name}</h1>
            </div>
            { this.state.location_data.status_code === 1 &&
            <NavLink to={`${local_routes.cities}/${friendlyUrl}`}>
              <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                Back to City
              </Button>
            </NavLink>
            }
          </div>
        </div>
      </div>
    );
  }
  
  /*
  bannerApiImageEmpty = () => {
    const { city_name } = this.state;
    const { match } = this.props;
    const friendlyUrl = _get(match, 'params.friendly_url', '');
    return (
      <div>
        <div className="bannerEventImage city-chicago">
          <img src={CityImage} className="city-img" alt="img" />
          <div className="container contentPosition">
            <h1 className="cityName">{city_name}</h1>
            <NavLink to={`${local_routes.cities}/${friendlyUrl}`}>
              <Button theme="btn-global Form_Btn_Pad font-normal marTop5 back-cityBtn">
                Back to City
              </Button>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
  */
  // Banner section End
  // Event Table Section Starts
  /*
  eventTable = () => {
  }
  

  createEvent = (data) => {
    this.setState({
      editEventData: data,
      pageStatus: 2
    })
  }
  

  resetToList = (status,successFriendlyUrl,successEntityName) => {
    if(status === true)
    {
      this.setState({showSuccessData:true,successFriendlyUrl:successFriendlyUrl,successEntityName:successEntityName})
    }
    this.setState({
      pageStatus: 1
    })
  }
  */
  

  render() {
    const { match: { params: { friendly_url } = {} } = {} } = this.props;

    console.log("EditCity render this.props",this.props)
    //const { currentTab,allowed,pageLoader, pageStatus,successFriendlyUrl, successEntityName,editEventData,showSuccessData } = this.state;
    const { currentTab, allowed, pageLoader } = this.state;

    if (!allowed) {
        return (
            <div className="empty-msg">
                <EmptyMessage empty_message="Not allowed to edit this city" />
            </div>
        );
    }
    
    if (!currentTab) {
      return (
        <Redirect to={`${local_routes.managecity}/${friendly_url}/main`} />
      )
    }

    if (pageLoader) {
        return (
            <FullPageSpinner />
        );
    }
    

        return (
          <React.Fragment>
          <Helmet>
            <title>Edit PechaKucha City</title>
            <meta name="robots" content="noindex" />
          </Helmet>
          <React.Fragment>
            <div className="main-section editCityData">
              {/* Banner section starts */}
              
              
                <ManageBanner
                  entity_name={this.state.location_data.entity_name}
                  carousel_images={[this.state.location_data.city_image]}
                  back_link={local_routes.cities+'/'+friendly_url}
                />
              
              {/* Banner section Ends */}
              <div className="editCityBg">
                <div className="container editCityMenu ">
                  <Col lg={12} className="pad-mb0 pad0">
                    <div>
                      <div className="sub-menu-nav" style={{borderBottom: "medium none"}}>
                        
                        <ul>
                          <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${local_routes.managecity}/${friendly_url}/main`}>INFO</NavLink></li>
                          <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${local_routes.managecity}/${friendly_url}/events`}>EVENTS</NavLink></li>
                          <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${local_routes.managecity}/${friendly_url}/venues`}>VENUES</NavLink></li>
                        </ul>
                        
                      </div>
                      {this.state.currentTab === 'main' &&
                        <CityInfo {...this.props}/>
                      }
                      {this.state.currentTab === 'events' &&
                        <EventList
                          //user_data={this.user_data}
                          source_info={{...this.state.location_data,entity_type:'locations'}}
                          referrer={`${local_routes.managecity}/${this.state.location_data.friendly_url}/events`}
                        />
                      }
                      {this.state.currentTab === 'venues' &&
                        <Venues {...this.props}/>
                      }
                    </div>

                    
                  </Col>
                </div>
              </div>
              {/* Banner sub navigation starts */}
              {/* Banner sub navigation ends */}
              <Footer
                homeImg={home}
                homeImgRef="/"
                breadcrumbMainPage="City"
                breadcrumbSubPage="Manage City"
                mainPageLink={`${local_routes.cities}/${this.state.location_data.friendly_url}`} />
            </div>
          </React.Fragment>
          </React.Fragment>
        );
      }
  
}

export default withRouter(EditCity);
